export default {
    _prefix: "ScorableActionNotices",
    messages: {
        maxDisputes:
            "The maximum number of disputes permitted for this evaluation has been reached.",
        maxTimeDispute:
            "The maximum amount of time has passed to dispute this evaluation.",
        maxTimeDecline:
            "The maximum amount of time has passed to decline the dispute on this evaluation.",
    },
};
